module.exports = __webpack_public_path__ + "img/sidebar-5.e9754a70.jpg";